import Resource from './resource';
import request from "../utils/request";

class DataCards extends Resource {
    constructor() {
        super('data_cards');
    }

    store(resource) {
        return request({
            url: `/group_cards/store`,
            method: 'post',
            data: resource
        })
    }

    list(resource) {
        return request({
            url: `/group_cards/list`,
            method: 'POST',
            data: resource
        })
    }

    delete(id) {
        return request({
            url: `/group_cards/delete/${id}`,
            method: 'delete',
        })
    }

    show(id) {
        return request({
            url: `/group_cards/show/${id}`,
            method: 'get',
        })
    }

    update(id, data) {
        return request({
            url: `/group_cards/update/${id}`,
            method: 'post',
            data: data
        })
    }

    removeMember(id, userId) {
        return request({
            url: `/group_cards/removeUsersFromGroupCard/${id}`,
            method: 'post',
            data: {
                users: [userId]
            }
        })
    }
}

export { DataCards as default };
